module.exports = __webpack_public_path__ + "static/media/5C.978eda8c.jpg";